export default "__VITE_ASSET__Cy131KuS__"